import { useEffect, useState } from 'react';
import { getOffers } from '../../../auth/_requests';

export const useRedeemStreak = (token?: string) => {
  const [streak, setStreak] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchStreak = async () => {
      if (!token) return;
      setLoading(true);
      try {
        const offers = await getOffers(token);
        const streakOffer = offers.find((task) => task.code === 'rentPayment3MonthStreak');
        setStreak(streakOffer?.progress?.completedCount ?? 0);
      } catch (error) {
        console.error('Error fetching payment streak:', error);
        setStreak(0);
      } finally {
        setLoading(false);
      }
    };

    void fetchStreak();
  }, [token]);

  return { streak, loading };
};
